import { useTranslation } from 'react-i18next';

const amenityKeys = [
  { icon: 'ri-sun-line', key: 'feat_private_pool' },
  { icon: 'ri-compass-3-line', key: 'feat_sea_views' },
  { icon: 'ri-wifi-line', key: 'feat_wifi' },
  { icon: 'ri-parking-box-line', key: 'feat_parking' },
  { icon: 'ri-fridge-line', key: 'feat_kitchen' },
  { icon: 'ri-fire-line', key: 'feat_bbq' },
  { icon: 'ri-key-2-line', key: 'feat_self_checkin' },
  { icon: 'ri-computer-line', key: 'feat_workspace' },
  { icon: 'ri-hearts-line', key: 'feat_family' },
  { icon: 'ri-plant-line', key: 'feat_garden_terrace' },
];

export default function BuenlugarAmenities() {
  const { t } = useTranslation();

  return (
    <section id="amenities" className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">{t('amenities_subtitle')}</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950">{t('amenities_title')}</h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {amenityKeys.map((item, i) => (
            <div
              key={item.key}
              className="flex flex-col items-center text-center p-5 md:p-6 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors duration-300 cursor-default group"
              style={{
                animation: `fadeInUp 0.6s ease-out ${i * 0.08}s forwards`,
                opacity: 0,
              }}
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center text-primary-500 mb-3 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </span>
              <span className="text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">{t(item.key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}